import { dataCrop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCrop = /*#__PURE__*/createIcon(dataCrop)
export default IconCrop
